"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var DatePickerProps_1 = require("./DatePickerProps");
var styles = require("./DatePicker.css");
var icons = require("./../../../styles/att-icons.css");
var key_press_1 = require("../../../utils/key-press");
var utils_1 = require("../../../utils");
var monthNames = ['January', 'February', 'March', 'April', 'May',
    'June', 'July', 'August', 'September', 'October', 'November', 'December'];
var esMonthNames = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo',
    'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
var dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thrusday', 'Friday', 'Saturday'];
var shortDayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
var esDayNames = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
var shortEsDayNames = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];
var DatePicker = /** @class */ (function (_super) {
    __extends(DatePicker, _super);
    function DatePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.htmlContent = [];
        _this.getTableBody = function () {
            if (_this.state.showMonths) {
                return _this.getMonthView(_this.state.selectedDate);
            }
            else {
                return (React.createElement("tbody", null,
                    React.createElement("tr", { className: styles.dayNames }, _this.getDaysColumn()),
                    _this.getTableData()));
            }
        };
        _this.getTableData = function () {
            var dayPerMonth = [31, _this.getFebDays(), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
            var nextMonth = _this.state.month !== 11 ? _this.state.month + 1 : 12;
            var prevMonth = _this.state.month !== 0 ? _this.state.month - 1 : 11;
            var day = _this.state.day;
            var monthFirstDate = new Date(nextMonth + '/01/' + _this.state.year);
            var weekdays = monthFirstDate.getDay();
            var weekdays2 = weekdays;
            var numOfDays = dayPerMonth[_this.state.month];
            var rowElements = [];
            var cellElements = [];
            var counter = 1;
            var prevMonthDays = dayPerMonth[prevMonth];
            prevMonthDays = prevMonthDays - weekdays + 1;
            while (weekdays > 0) {
                cellElements.push(_this.getDateColumn(prevMonthDays, day, prevMonth + 1, true));
                prevMonthDays++;
                weekdays--;
            }
            var firstRowData = 7 - weekdays2;
            while (firstRowData > 0) {
                cellElements.push(_this.getDateColumn(counter, day, _this.state.month + 1, false));
                counter++;
                firstRowData--;
            }
            rowElements.push(React.createElement("tr", { ref: _this.selectRef }, cellElements));
            cellElements = [];
            while (counter <= numOfDays) {
                if (weekdays > 6) {
                    weekdays = 0;
                    rowElements.push(React.createElement("tr", { ref: _this.selectRef }, cellElements));
                    cellElements = [];
                }
                cellElements.push(_this.getDateColumn(counter, day, _this.state.month + 1, false));
                weekdays++;
                counter++;
            }
            counter = 1;
            while (weekdays <= 6) {
                cellElements.push(_this.getDateColumn(counter, day, nextMonth + 1, true));
                weekdays++;
                counter++;
            }
            if (cellElements.length !== 0) {
                rowElements.push(React.createElement("tr", { ref: _this.selectRef }, cellElements));
            }
            return rowElements;
        };
        var dateNow = _this.props.data && _this.props.data.defaultDate || new Date();
        var language = _this.props.options && _this.props.options.lang;
        if (language === null || language === undefined) {
            language = window.location.href.indexOf('es-us') !== -1 ? DatePickerProps_1.LangType.ES : DatePickerProps_1.LangType.EN;
        }
        _this.state = {
            day: dateNow.getDate(),
            lang: language,
            month: dateNow.getMonth(),
            selectedDate: _this.props.data && _this.props.data.defaultDate,
            showCal: _this.props.options && _this.props.options.defaultOpen,
            showMonths: false,
            year: dateNow.getFullYear(),
        };
        _this.prev = _this.prev.bind(_this);
        _this.next = _this.next.bind(_this);
        _this.renderInputOrButton = _this.renderInputOrButton.bind(_this);
        _this.getDateColumn = _this.getDateColumn.bind(_this);
        _this.getTableBody = _this.getTableBody.bind(_this);
        _this.getTableData = _this.getTableData.bind(_this);
        _this.getFebDays = _this.getFebDays.bind(_this);
        _this.handleDateSelect = _this.handleDateSelect.bind(_this);
        _this.setData = _this.setData.bind(_this);
        _this.handleInputClear = _this.handleInputClear.bind(_this);
        _this.handleInputChange = _this.handleInputChange.bind(_this);
        _this.handleInputBlur = _this.handleInputBlur.bind(_this);
        _this.handleKeyDown = _this.handleKeyDown.bind(_this);
        _this.openCalender = _this.openCalender.bind(_this);
        _this.closeCalender = _this.closeCalender.bind(_this);
        _this.handleCalenderButtonClick = _this.handleCalenderButtonClick.bind(_this);
        _this.getDayName = _this.getDayName.bind(_this);
        _this.getShortDayName = _this.getShortDayName.bind(_this);
        _this.getDaysColumn = _this.getDaysColumn.bind(_this);
        _this.getMonthName = _this.getMonthName.bind(_this);
        _this.selectRef = {};
        _this.handleKeyDownPress = _this.handleKeyDownPress.bind(_this);
        _this.handleMonthYearLink = _this.handleMonthYearLink.bind(_this);
        _this.handleMonthSelect = _this.handleMonthSelect.bind(_this);
        _this.handleMonthKeyPress = _this.handleMonthKeyPress.bind(_this);
        _this.handleMonthYearLinkkeyPress = _this.handleMonthYearLinkkeyPress.bind(_this);
        _this.showCalendarLegends = _this.showCalendarLegends.bind(_this);
        return _this;
    }
    DatePicker.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.data && nextProps.data.defaultDate && nextProps.data.defaultDate !== this.state.selectedDate) {
            this.setState({
                day: nextProps.data.defaultDate.getDate(),
                month: nextProps.data.defaultDate.getMonth(),
                selectedDate: nextProps.data.defaultDate,
                year: nextProps.data.defaultDate.getFullYear(),
            });
        }
    };
    DatePicker.prototype.getDaysColumn = function () {
        var dayColumns = [];
        var counter = 0;
        while (counter < 7) {
            dayColumns.push(React.createElement("td", { "aria-label": this.getDayName(counter), tabIndex: 0, role: "heading" },
                React.createElement("div", { "aria-hidden": "true" }, this.getShortDayName(counter))));
            counter++;
        }
        return dayColumns;
    };
    DatePicker.prototype.getFebDays = function () {
        if ((this.state.year % 100 !== 0) && (this.state.year % 4 === 0) || (this.state.year % 400 === 0)) {
            return 29;
        }
        else {
            return 28;
        }
    };
    DatePicker.prototype.getDateColumn = function (counter, day, month, disabled) {
        var dateToHighlight;
        var selectedDate = this.state.selectedDate || new Date();
        var selectedMonth = selectedDate.getMonth() + 1;
        var cellDate = this.getDate(counter, month, this.state.year);
        if (this.props.data && this.props.data.highlightDate) {
            dateToHighlight = this.props.data.highlightDate.getTime() === cellDate.getTime();
        }
        if (!disabled && this.props.data && this.props.data.beforDate) {
            disabled = this.props.data.beforDate.getTime() >= cellDate.getTime();
        }
        if (!disabled && this.props.data && this.props.data.afterDate) {
            disabled = this.props.data.afterDate.getTime() <= cellDate.getTime();
        }
        if (!disabled && this.props.options && this.props.options.disabledDates) {
            var temp = this.props.options.disabledDates.find(function (date) {
                return (date.toDateString() === cellDate.toDateString());
            });
            disabled = temp !== null && temp !== undefined;
        }
        if (!disabled && this.props.options && this.props.options.disabledDays) {
            disabled = this.props.options.disabledDays.includes(cellDate.getDay());
        }
        if (!disabled && this.props.data && this.props.data.customDisabledDate) {
            disabled = this.props.data.customDisabledDate.getTime() === cellDate.getTime();
        }
        var customDisabledDate = this.props.data && this.props.data.customDisabledDate &&
            this.props.data.customDisabledDate.getTime() === cellDate.getTime();
        var disabledClassName = this.props.options && customDisabledDate && this.props.options.disabledClass ?
            this.props.options.disabledClass : styles.disabled;
        var highlightedClassName = this.props.options && this.props.options.highlightCustomClass ?
            this.props.options.highlightCustomClass : styles.selectedDate;
        var isSelected = !disabled && counter === day && selectedMonth === month &&
            this.state.year === selectedDate.getFullYear();
        var selectedClassName = this.props.options && this.props.options.selectionCustomClass ?
            this.props.options.selectionCustomClass : styles.selectedDate;
        var overrideSelectionClass = this.props.options && this.props.options.overrideSelectionClass ?
            this.props.options.overrideSelectionClass : styles.selectedDate;
        var classes = (isSelected || dateToHighlight) ? [styles.dayNow]
            : [styles.monthNow];
        var className = '';
        if (overrideSelectionClass && dateToHighlight) {
            className = highlightedClassName;
        }
        else if (isSelected) {
            className = selectedClassName;
        }
        if (disabled) {
            classes.push(disabledClassName);
        }
        return (React.createElement("td", { className: classes.join(' '), onClick: disabled ? undefined : this.handleDateSelect, "aria-label": disabled ? 'disabled' : this.getMonthName(this.state.month) + ' ' + counter, tabIndex: disabled ? -1 : 0, role: "button", onKeyDown: this.handleKeyDownPress },
            React.createElement("div", { "aria-hidden": "true", className: className }, counter)));
    };
    DatePicker.prototype.prev = function () {
        if (this.state.showMonths) {
            this.setState({ year: (this.state.year - 1) });
        }
        else {
            if (this.state.month === 0) {
                this.setState({ month: 11, year: (this.state.year - 1) });
            }
            else {
                this.setState({ month: (this.state.month - 1) });
            }
        }
    };
    DatePicker.prototype.next = function () {
        if (this.state.showMonths) {
            this.setState({ year: (this.state.year + 1) });
        }
        else {
            if (this.state.month === 11) {
                this.setState({ month: 0, year: (this.state.year + 1) });
            }
            else {
                this.setState({ month: (this.state.month + 1) });
            }
        }
    };
    DatePicker.prototype.handleDateSelect = function (e) {
        var selectedDay = Number(e.currentTarget.innerText);
        var currentdate = new Date(this.state.month + 1 + '/' + selectedDay + '/' + this.state.year);
        this.setState({ day: currentdate.getDate(), selectedDate: currentdate,
            showCal: this.props.options && this.props.options.noCloseOnDateSelect
                ? true : false });
        if (this.props.events && this.props.events.onDateSelect) {
            this.props.events.onDateSelect(currentdate);
        }
    };
    DatePicker.prototype.handleInputClear = function () {
        this.setData(undefined, undefined);
        if (this.props.events && this.props.events.onInputClear) {
            this.props.events.onInputClear();
        }
    };
    DatePicker.prototype.handleInputChange = function (e) {
        var text = e.currentTarget.value;
        var date = new Date(text);
        if (this.isValidDate(text)) {
            var dateStr = date.toLocaleDateString();
            if (dateStr.toLowerCase() !== 'invalid date') {
                this.setData(date, null);
            }
            else {
                this.setData(null, text);
            }
        }
        else {
            this.setData(null, text);
        }
        if (this.props.events && this.props.events.onInputchange) {
            this.props.events.onInputchange(text);
        }
    };
    DatePicker.prototype.handleInputBlur = function (e) {
        if (this.props.events && this.props.events.onInputBlur) {
            this.props.events.onInputBlur(e.currentTarget.value);
        }
    };
    DatePicker.prototype.handleKeyDown = function (e) {
        var isValidKeyPressed = key_press_1.KeyPress.forwardSlashIsPressed(e) ||
            key_press_1.KeyPress.deleteIsPressed(e) ||
            key_press_1.KeyPress.backspaceIsPressed(e) ||
            key_press_1.KeyPress.tabIsPressed(e) ||
            key_press_1.KeyPress.shiftIsPressed(e) ||
            key_press_1.KeyPress.escIsPressed(e) ||
            this.isNumberOnly(e.key);
        if (!isValidKeyPressed) {
            e.preventDefault();
            e.stopPropagation();
        }
    };
    DatePicker.prototype.handleKeyDownPress = function (e) {
        // get children of parent - using id - e of index => e of index+1 - focus
        var theElem;
        var isValidKeyPressed = key_press_1.KeyPress.rightArrowIsPressed(e);
        if (key_press_1.KeyPress.enterIsPressed(e)) {
            var selectedDay = e.currentTarget.innerText;
            var currentdate = new Date(this.state.month + 1 + '/' + selectedDay + '/' + this.state.year);
            this.setState({ day: currentdate.getDate(), selectedDate: currentdate, showCal: false });
            if (this.props.events && this.props.events.onDateSelect) {
                this.props.events.onDateSelect(currentdate);
            }
        }
        if (key_press_1.KeyPress.rightArrowIsPressed(e)) {
            if (this.selectRef && this.selectRef.current &&
                (e.currentTarget.cellIndex !== (e.currentTarget.parentElement.children.length - 1))) {
                theElem = e.currentTarget.parentElement.children[e.currentTarget.cellIndex + 1];
                theElem.focus();
            }
        }
        if (key_press_1.KeyPress.leftArrowIsPressed(e)) {
            if (this.selectRef && this.selectRef.current && (e.currentTarget.cellIndex !== 0)) {
                theElem = e.currentTarget.parentElement.children[e.currentTarget.cellIndex - 1];
                theElem.focus();
            }
        }
        if (key_press_1.KeyPress.upArrowIsPressed(e)) {
            if (this.selectRef && this.selectRef.current) {
                theElem = e.currentTarget.parentElement.previousElementSibling.children[e.currentTarget.cellIndex];
                theElem.focus();
            }
        }
        if (key_press_1.KeyPress.downArrowIsPressed(e)) {
            if (this.selectRef && this.selectRef.current) {
                theElem = e.currentTarget.parentElement.nextElementSibling.children[e.currentTarget.cellIndex];
                theElem.focus();
            }
        }
        if (key_press_1.KeyPress.tabIsPressed(e)) {
            if (this.selectRef && this.selectRef.current) {
                var parentRowElement = e.currentTarget.parentElement;
                if (key_press_1.KeyPress.shiftIsPressed(e)) {
                    if (parentRowElement.rowIndex > 0 &&
                        e.currentTarget.parentElement !== undefined &&
                        (e.currentTarget.cellIndex === 0)) {
                        theElem = e.currentTarget.parentElement.previousElementSibling.children[e.currentTarget.parentElement.children.length - 1];
                    }
                    else {
                        theElem = e.currentTarget.parentElement.children[e.currentTarget.cellIndex - 1];
                    }
                }
                else {
                    if (parentRowElement.rowIndex + 1 !== undefined &&
                        e.currentTarget.parentElement !== undefined &&
                        (e.currentTarget.cellIndex === (e.currentTarget.parentElement.children.length - 1))) {
                        theElem = e.currentTarget.parentElement.nextElementSibling.children[0];
                    }
                    else {
                        theElem = e.currentTarget.parentElement.children[e.currentTarget.cellIndex + 1];
                    }
                }
                theElem.focus();
            }
        }
        if (!isValidKeyPressed) {
            e.preventDefault();
            e.stopPropagation();
        }
    };
    DatePicker.prototype.setData = function (selectedDate1, inputText) {
        var currentdate = new Date();
        this.setState({
            currentText: inputText,
            day: selectedDate1 && selectedDate1.getDate() || currentdate.getDate(),
            month: selectedDate1 && selectedDate1.getMonth() || currentdate.getMonth(),
            selectedDate: selectedDate1,
            year: selectedDate1 && selectedDate1.getFullYear() || currentdate.getFullYear(),
        });
    };
    DatePicker.prototype.openCalender = function () {
        if (!this.state.showCal) {
            this.setState({ showCal: true });
        }
    };
    DatePicker.prototype.closeCalender = function () {
        if (this.state.showCal) {
            this.setState({ showCal: false });
        }
    };
    DatePicker.prototype.handleCalenderButtonClick = function () {
        !this.state.showCal ? this.openCalender() : this.closeCalender();
    };
    DatePicker.prototype.handleMonthYearLink = function () {
        this.setState({ showMonths: true });
    };
    DatePicker.prototype.handleMonthYearLinkkeyPress = function (e) {
        if (key_press_1.KeyPress.enterIsPressed(e)) {
            this.setState({ showMonths: true });
        }
    };
    DatePicker.prototype.handleMonthSelect = function (e) {
        var monthNo = Number(e.currentTarget.id);
        this.setState({ month: monthNo, showMonths: false });
    };
    DatePicker.prototype.handleMonthKeyPress = function (e) {
        if (key_press_1.KeyPress.enterIsPressed(e)) {
            var id = Number(e.currentTarget.id);
            this.setState({ month: id, showMonths: false });
        }
    };
    DatePicker.prototype.renderInputOrButton = function () {
        if (this.props.options && this.props.options.type === DatePickerProps_1.DatePickerType.INPUT) {
            var dateOptions = this.props.options.dateFormat || {};
            var locale = this.props.options &&
                this.props.options.lang ?
                this.props.options.lang + "-us" : 'en-us';
            var inputText = this.state.selectedDate &&
                this.state.selectedDate.toLocaleString(locale, dateOptions) ||
                this.state.currentText || '';
            return (React.createElement(React.Fragment, null,
                React.createElement("span", { className: [styles.dateInputHolder, this.props.options.disabled ? styles.disabled : ''].join(' ') },
                    React.createElement("i", { className: [icons.attIcon, icons.attIconCalendar].join(' '), onClick: this.handleCalenderButtonClick }),
                    React.createElement("input", { type: "datetime", value: inputText, placeholder: this.props.options && this.props.options.placeholder, onChange: !this.props.options.disabled ? this.handleInputChange : null, onKeyDown: !this.props.options.disabled ? this.handleKeyDown : null, onFocus: !this.props.options.disabled ? this.openCalender : null, onBlur: !this.props.options.disabled ? this.handleInputBlur : null, disabled: this.props.options.disabled }),
                    this.state.selectedDate &&
                        React.createElement("i", { "aria-label": "Clear text", className: [icons.attIcon, icons.attIconXClose].join(' '), onClick: !this.props.options.disabled ? this.handleInputClear : null }))));
        }
        else {
            return (React.createElement("span", { className: styles.dateInputHolder },
                React.createElement("i", { className: [icons.attIcon, icons.attIconCalendar].join(' '), onClick: this.handleCalenderButtonClick })));
        }
    };
    DatePicker.prototype.render = function () {
        var monthName = this.getMonthName(this.state.month);
        return (React.createElement("div", { "data-test-id": utils_1.default(this.props.testId, 'DatePicker'), className: styles.datepicker },
            this.renderInputOrButton(),
            !this.props.options.disabled && this.state.showCal &&
                React.createElement("div", { className: styles.calendarHolder },
                    React.createElement("i", { className: styles.tip }),
                    React.createElement("table", null,
                        React.createElement("thead", null,
                            React.createElement("tr", { className: styles.monthNow },
                                React.createElement("th", null,
                                    React.createElement("button", { "aria-label": 'Previous ' + (this.state.showMonths ? 'Year' : 'Month'), onClick: this.prev },
                                        React.createElement("i", { className: [icons.attIcon, icons.attIconLeft].join(' ') }))),
                                React.createElement("th", { colSpan: this.state.showMonths ? 2 : 5, "aria-label": (!this.state.showMonths && monthName) + ' ' + this.state.year, role: "heading" },
                                    React.createElement("div", { "aria-hidden": "true", tabIndex: 0, onClick: this.handleMonthYearLink, onKeyDown: this.handleMonthYearLinkkeyPress },
                                        !this.state.showMonths && monthName,
                                        " ",
                                        this.state.year)),
                                React.createElement("th", null,
                                    React.createElement("button", { "aria-label": 'Next ' + (this.state.showMonths ? 'Year' : 'Month'), onClick: this.next },
                                        React.createElement("i", { className: [icons.attIcon, icons.attIconRight].join(' ') }))))),
                        this.getTableBody(),
                        this.showCalendarLegends()))));
    };
    DatePicker.prototype.getMonthView = function (selectedDate) {
        var currMonth = selectedDate || new Date();
        var monthRows = [];
        var monthColumns = [];
        var i = 0;
        while (i < monthNames.length) {
            var monthName = this.getMonthName(i);
            monthColumns.push(React.createElement("td", { id: '' + i, "aria-label": monthName, tabIndex: 0, onClick: this.handleMonthSelect, onKeyDown: this.handleMonthKeyPress, className: styles.monthName +
                    ((currMonth.getMonth() === i && currMonth.getFullYear() === this.state.year)
                        ? ' ' + styles.currentMonth : '') },
                React.createElement("span", { "aria-hidden": true, tabIndex: -1 }, monthName.substr(0, 3))));
            i++;
            if (i % 4 === 0) {
                monthRows.push(React.createElement("tr", null,
                    " ",
                    monthColumns));
                monthColumns = [];
            }
        }
        return (React.createElement("tbody", null, monthRows));
    };
    DatePicker.prototype.getMonthName = function (month) {
        if (month !== undefined &&
            this.props.data && this.props.data.monthNameList && this.props.data.monthNameList.length === 12) {
            return this.props.data.daysNameList[month];
        }
        else {
            return month !== undefined && this.state.lang === DatePickerProps_1.LangType.ES ? esMonthNames[month] : monthNames[month];
        }
    };
    DatePicker.prototype.getDayName = function (day) {
        return day !== undefined && this.state.lang === DatePickerProps_1.LangType.ES ? esDayNames[day] : dayNames[day];
    };
    DatePicker.prototype.getShortDayName = function (day) {
        if (day !== undefined &&
            this.props.data && this.props.data.daysNameList && this.props.data.daysNameList.length === 7) {
            return this.props.data.daysNameList[day];
        }
        else {
            return day !== undefined && this.state.lang === DatePickerProps_1.LangType.ES ? shortEsDayNames[day] : shortDayNames[day];
        }
    };
    DatePicker.prototype.getDate = function (day, month, year) {
        return new Date(month + '/' + day + '/' + year);
    };
    DatePicker.prototype.isValidDate = function (testdate) {
        return /^\d{2}\/\d{2}\/\d{4}$/.test(testdate);
    };
    DatePicker.prototype.isNumberOnly = function (text) {
        return /^[0-9]*$/.test(text);
    };
    DatePicker.prototype.showCalendarLegends = function () {
        var legendMessages = [];
        if (this.props.legendMessages) {
            this.props.legendMessages.forEach(function (legendMessageValue, index) {
                legendMessages.push(React.createElement("li", { key: index, className: styles.calendarLegend },
                    React.createElement("i", { className: legendMessageValue.legendMessage && legendMessageValue.legendMessage.messageCustomClass ?
                            legendMessageValue.legendMessage.messageCustomClass : styles.defaultCalendarLegend, "aria-hidden": "true" }),
                    legendMessageValue.legendMessage && legendMessageValue.legendMessage.displayMessage));
            });
            return (React.createElement("tfoot", null,
                React.createElement("tr", null,
                    React.createElement("td", { colSpan: 7, tabIndex: 0, "aria-label": "Legend Message" },
                        React.createElement("div", { "aria-hidden": "true" }, legendMessages)))));
        }
    };
    return DatePicker;
}(React.Component));
exports.default = DatePicker;
//# sourceMappingURL=DatePicker.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/DatePicker/DatePicker.js
// module id = 1143
// module chunks = 8